export enum UserInvitationType {
  Talent = 'talent',
  Organization = 'organization',
}
